import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { routes } from '@lean-body/src/route';
import { useMissionNotificationStore } from '../stores/mission_notification_store';
export const useMissionNotification = (apiClient, isDormant) => {
    const location = useLocation();
    const setHasUnviewedMissions = useMissionNotificationStore((state) => state.setHasUnviewedMissions);
    React.useEffect(() => {
        if (isDormant || routes.MISSIONS.matchPath(location.pathname)) {
            return;
        }
        let isMounted = true;
        apiClient.fetchMissionSummary().then((missionSummary) => {
            if (isMounted) {
                setHasUnviewedMissions(missionSummary.hasUnviewedMissions);
            }
        });
        return () => {
            isMounted = false;
        };
    }, [apiClient, isDormant, location.pathname, setHasUnviewedMissions]);
};
